import {
  ApplicationRef,
  ComponentRef,
  inject,
  Injectable
} from "@angular/core";

@Injectable()
export class AttachViewService {
  readonly #map: Map<Object, ComponentRef<unknown>[]> = new Map();

  readonly #applicationRef = inject(ApplicationRef);

  attach(name: Object, componentRef: ComponentRef<unknown>): void {
    if (!this.#map.has(name)) {
      this.#map.set(name, []);
    }

    this.#map.get(name)!.push(componentRef);
    this.#applicationRef.attachView(componentRef.hostView);
  }

  detachAll(name: Object): void {
    const list: ComponentRef<unknown>[] = this.#map.get(name) ?? [];
    list.forEach((componentRef: ComponentRef<unknown>) => {
      this.#applicationRef.detachView(componentRef.hostView);
    });
  }
}
